import React, { useState } from 'react';
import Sidebar from './Sidebar';
import BlogSection from './BlogSection/BlogSection';
import BlogForm from './BlogSection/BlogForm';
import VerifyBlog from './BlogSection/VerifyBlog';
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import EditBlog from './BlogSection/EditBlog';
import AffiliateSection from './AffiliateSection/AffiliateSection';
import VerifyAffiliate from './AffiliateSection/VerifyAffiliate';
import AffiliateForm from './AffiliateSection/AffiliateForm';
import MeditationSection from './MeditationSection/MeditationSection';
import SandhayaSection from './SandhayaSection/SandhayaSection';
import LibrarySection from './LibrarySection/LibrarySection';
import AddNewLibrary from './LibrarySection/AddNewLibrary';
import EditMeditation from './MeditationSection/EditMeditation';
import EditSandhaya from './SandhayaSection/EditSandhaya';
import AddMeditation from './MeditationSection/AddMeditation';
import AddSandhaya from './SandhayaSection/AddSandhaya';
import TodaysSandhaya from './SandhayaSection/TodaysSandhaya';
import EmotionSection from './EmotionSection/EmotionSection';
import EditEmotion from './EmotionSection/EditEmotion';
import AddEmotion from './EmotionSection/AddEmotion';
import DailyQoutes from './DailyQuotesSection/DailyQoutes';
import EditDailyQuotes from './DailyQuotesSection/EditDailyQuotes';
import OnlineEvents from './OnlineEventSection/OnlineEvents';
import EditOnlineEvents from './OnlineEventSection/EditOnlineEvents';
import EditLibrary from './LibrarySection/EditLibrary';
import MantraSection from './MantraSection/MantraSection';
import MantraForm from './MantraSection/MantraForm';
import VerifyMantra from './MantraSection/VerifyMantra';
import EditMantra from './MantraSection/EditMantra';

const Dashboard = () => {
  const [formValue, setFormValue] = useState({});
  const [affiliateValue, setAffiliateValue] = useState({});
  const [editFormValue, setEditFormValue] = useState({});
  const [option, setoption] = useState("1");
  const [mantraValue, setMantraValue] = useState({});
  const [editMantraValue, setEditMantraValue] = useState({});
  const [editMeditation, setEditMeditation] = useState({});
  const [editEmotion, setEditEmotion] = useState({});
  const [editSandhaya, setEditSandhaya] = useState({});
  const [editDailyQuote, setEditDailyQuote] = useState([]);
  const [editEvent, setEditEvent] = useState([]);
  const [editLibrary, setEditLibrary] = useState([]);
  const isFormOpen = useSelector((store) => store.app.isFormOpen);
  const isVerifyOpen = useSelector((store) => store.verifyblog.isVerifyOpen);
  const isEditOpen = useSelector((store) => store.editblog.isEditOpen);
  const isMantraFormOpen = useSelector((store) => store.mantraAdd.isFormOpen);
  const isMantraVerifyOpen = useSelector((store) => store.verifyMantra.isVerifyOpen);
  const isMantraEditOpen = useSelector((store) => store.editMantra.isEditOpen);
  const isAffiliateFormOpen = useSelector((store) => store.affiliateForm.isAffiliateFormOpen);
  const isVerifyAffiliateOpen = useSelector((store) => store.verifyAffiliate.isVerifyAffiliateOpen);
  const isLibraryAddOpen = useSelector((store) => store.libraryAdd.isLibraryAddOpen);
  const isLibraryEditOpen = useSelector((store) => store.libraryEdit.isLibraryEditOpen);
  const isMeditationEditOpen = useSelector((store) => store.meditationEdit.isMeditationEditOpen);
  const isMeditationAddOpen = useSelector((store) => store.meditationAdd.isMeditationAddOpen);
  const isSandhayaEditOpen = useSelector((store) => store.sandhayaEdit.isSandhayaEditOpen);
  const isSandhayaAddOpen = useSelector((store) => store.sandhayaAdd.isSandhayaAddOpen);
  const isEmotionEditOpen = useSelector((store) => store.emotionEdit.isEmotionEditOpen);
  const isEmotionAddOpen = useSelector((store) => store.emotionAdd.isEmotionAddOpen);
  const isDailyQuotesOpen = useSelector((store) => store.dailyQuotes.isDailyQuotesOpen);
  const isTodaySandhayaAddOpen = useSelector((store) => store.todaySandhayaAdd.isTodaySandhayaAddOpen);
  const isOnlineEventOpen = useSelector((store) => store.onlineEvent.isOnlineEventOpen);
  const loginData = useSelector((store) => store.login.details);

  if(loginData === "notexist"){
    return (
      <div className="max-h-full fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 flex justify-center">
        <div className='lg:md:w-[30vw] w-[70vw] h-[110px] bg-[#FFF] rounded-xl drop-shadow-3Xl flex flex-col items-center justify-center gap-4'>
          <div className="text-[#000] text-2xl font-figtree font-bold">Please Login First!!!</div>
          <Link to='/' className='lg:md:w-[18%] w-[25%] bg-[#3E84F8] rounded-[8px] px-4 py-2 text-[#FFF] text-sm text-center font-figtree font-semibold'>OK</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-[#F8FAFF] flex gap-14 lg:md:py-10 py-5 lg:md:pl-[24vw] pl-5 pr-5">
      <Sidebar setoption={setoption} option={option} />
      {option=== "1" && <BlogSection setEditFormValue={setEditFormValue} />}
      {isFormOpen && <BlogForm setFormValue={setFormValue} />}
      {isVerifyOpen && <VerifyBlog formValue={formValue} setFormValue={setFormValue} />}
      {isEditOpen && <EditBlog editFormValue={editFormValue} setEditFormValue={setEditFormValue} />}

      {option=== "2" && <MantraSection setEditMantraValue={setEditMantraValue} />}
      {isMantraFormOpen && <MantraForm setMantraValue={setMantraValue} />}
      {isMantraVerifyOpen && <VerifyMantra mantraValue={mantraValue} setMantraValue={setMantraValue} />}
      {isMantraEditOpen && <EditMantra editMantraValue={editMantraValue} setEditMantraValue={setEditMantraValue} />}

      {option=== "3" && <AffiliateSection />}
      {isAffiliateFormOpen && <AffiliateForm setAffiliateValue={setAffiliateValue} />}
      {isVerifyAffiliateOpen && <VerifyAffiliate affiliateValue={affiliateValue} setAffiliateValue={setAffiliateValue} />}

      {option=== "4" && <SandhayaSection setEditSandhaya={setEditSandhaya} />}
      {isSandhayaEditOpen && <EditSandhaya setEditSandhaya={setEditSandhaya} editSandhaya={editSandhaya} />}
      {isSandhayaAddOpen && <AddSandhaya />} 
      {isTodaySandhayaAddOpen && <TodaysSandhaya />}

      {option=== "5" && <MeditationSection setEditMeditation={setEditMeditation} />}
      {isMeditationEditOpen && <EditMeditation setEditMeditation={setEditMeditation} editMeditation={editMeditation} />}
      {isMeditationAddOpen && <AddMeditation />}

      {option=== "6" && <EmotionSection setEditEmotion={setEditEmotion} />}
      {isEmotionEditOpen && <EditEmotion setEditEmotion={setEditEmotion} editEmotion={editEmotion} />}
      {isEmotionAddOpen && <AddEmotion />}

      {option=== "7" && <LibrarySection setEditLibrary={setEditLibrary} />}
      {isLibraryAddOpen && <AddNewLibrary />}
      {isLibraryEditOpen && <EditLibrary setEditLibrary={setEditLibrary} editLibrary={editLibrary} />}

      {option=== "8" && <DailyQoutes setEditDailyQuote={setEditDailyQuote} />}
      {isDailyQuotesOpen && <EditDailyQuotes setEditDailyQuote={setEditDailyQuote} editDailyQuote={editDailyQuote} />}
      
      {option=== "9" && <OnlineEvents setEditEvent={setEditEvent} />}
      {isOnlineEventOpen && <EditOnlineEvents editEvent={editEvent} />}
    </div>
  );
}

export default Dashboard;